import { types, actions } from './requests'
export const GETDETAILEDJOBLIST_TYPES = {
    ...types('GETDETAILEDJOBLIST'),
}
export const GETDETAILEDJOBLIST_ACTIONS = {
    ...actions('GETDETAILEDJOBLIST'),
}
